import React from 'react';
import { arrayOf, bool, func, shape, string } from 'prop-types';
import { Checkbox, Grid, Divider } from '@mantine/core';


const OrgJobRow = ({
  job,
  selectedJobs,
  toggleJobSelected,
  replacementTokens,
  useJobCodeKey
}) => {
  
  const handleCheckboxToggle = () => {
    toggleJobSelected(job);
  };
  const selectedJobIds = selectedJobs.map(job => job.id);
  const orgJobCodeKey = replacementTokens.find(value => value.token === 'job_code_key_text');
  const orgJobCodeKeyLabel = orgJobCodeKey && orgJobCodeKey.value ? orgJobCodeKey.value : 'Job Code Key';
  
  return (
    <Grid key={job.id} style={{ marginTop: 4 }}>
      <Grid.Col span={1} size="lg" style={{ marginTop: 2 }}>
        <Checkbox
          checked={selectedJobIds.includes(job.id)}
          onChange={handleCheckboxToggle}
          color="#0FB2F6"
          size="md"
        />
      </Grid.Col>
      <Grid.Col span={11} size="lg">
        <strong>{job.org_job_title}</strong>
      </Grid.Col>
      <Grid.Col span="auto" style={{ paddingLeft: 51 }}>
        Job Code
        <span style={{ color: '#5C5C5C', fontWeight: 510, paddingLeft: 10 }}>{job.org_job_code}</span>
        {useJobCodeKey && (
          <>
            <span style={{ paddingLeft: 20 }}>{orgJobCodeKeyLabel}</span>
            <span style={{ color: '#5C5C5C', fontWeight: 510, paddingLeft: 10 }}>{job.org_job_code_key}</span>
          </>
        )}
      </Grid.Col>
      <Divider style={{ margin: '10px 0' }} />
    </Grid>
  );
};
OrgJobRow.propTypes = {
  job: shape({
    code: string,
    codeKey: string,
    id: string,
    name: string
  }),
  selectedJobs: arrayOf(
    shape({
      code: string,
      codeKey: string,
      currency: string,
      id: string,
      name: string
    })
  ),
  toggleJobSelected: func,
  replacementTokens: arrayOf(
    shape({
      token: string,
      value: string
    })
  ),
  useJobCodeKey: bool
};

export default OrgJobRow;
